import { render, staticRenderFns } from "./recordViews.vue?vue&type=template&id=7940305d&scoped=true&"
import script from "./recordViews.vue?vue&type=script&lang=js&"
export * from "./recordViews.vue?vue&type=script&lang=js&"
import style0 from "./recordViews.vue?vue&type=style&index=0&id=7940305d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7940305d",
  null
  
)

export default component.exports